import React from 'react';
import { Music, Music2, Zap, Lock, Shield, Zap as ZapIcon, GraduationCap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function HeroSection() {
  return <section className="gradient-hero w-full min-h-screen relative overflow-hidden flex items-center justify-center py-12 md:py-16 px-4" data-id="element-138">
      {/* Decorative floating music icons */}
      <div className="hidden sm:block absolute top-10 left-8 float-note opacity-60 select-none" aria-hidden="true" data-id="element-139">
        <Music className="w-10 h-10 text-yellow-300" data-id="element-140" />
      </div>
      <div className="hidden sm:block absolute top-24 right-12 float-note-delay opacity-60 select-none" aria-hidden="true" data-id="element-141">
        <Music2 className="w-8 h-8 text-white" data-id="element-142" />
      </div>
      <div className="hidden sm:block absolute bottom-20 left-16 float-note opacity-50 select-none" aria-hidden="true" data-id="element-143">
        <Music className="w-7 h-7 text-orange-200" data-id="element-144" />
      </div>
      <div className="hidden sm:block absolute bottom-32 right-8 float-note-delay opacity-50 select-none" aria-hidden="true" data-id="element-145">
        <Music2 className="w-9 h-9 text-yellow-200" data-id="element-146" />
      </div>
      <div className="hidden sm:block absolute top-1/2 left-4 float-note opacity-40 select-none" aria-hidden="true" data-id="element-147">
        <Music className="w-6 h-6 text-white" data-id="element-148" />
      </div>
      <div className="hidden sm:block absolute top-1/3 right-4 float-note-delay opacity-40 select-none" aria-hidden="true" data-id="element-149">
        <Music2 className="w-6 h-6 text-yellow-100" data-id="element-150" />
      </div>

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center gap-6 md:gap-8 relative z-10 w-full" data-id="element-151">
        {/* Tag pills */}
        <div className="flex flex-wrap justify-center gap-1.5 md:gap-2" data-id="element-152">
          {['Actividades', 'Canciones Mexicanas', 'Evaluaciones', 'Plantillas', 'Certificados'].map(tag => <span key={tag} className="bg-white/20 backdrop-blur-sm text-white text-xs md:text-sm font-semibold px-3 md:px-4 py-1 md:py-1.5 rounded-full border border-white/30" data-id="element-153">
              {tag}
            </span>)}
        </div>

        {/* Main headline */}
        <div data-id="element-154">
          <h1 className="font-nunito font-black text-white leading-tight" data-id="element-155">
            <span className="flex items-center justify-center gap-3 text-3xl sm:text-5xl md:text-7xl" data-id="element-156">
              <Music className="w-8 h-8 sm:w-12 sm:h-12 md:w-16 md:h-16 text-yellow-300 flex-shrink-0" data-id="element-157" />
              36 SEMANAS DE
            </span>
            <span className="shimmer-text text-4xl sm:text-6xl md:text-8xl block" data-id="element-158">
              MÚSICA LISTAS
            </span>
          </h1>
        </div>

        {/* Subheadline */}
        <p className="font-nunito font-bold text-white/90 text-base sm:text-xl md:text-2xl max-w-2xl leading-relaxed px-2" data-id="element-159">
          Planes Semanales para Maestros de Primaria{' '}
          <span className="bg-yellow-400 text-purple-900 px-2 py-0.5 rounded-md" data-id="element-160">
            SIN SER ESPECIALISTA
          </span>
        </p>

        {/* Product image */}
        <div className="relative" data-id="element-161">
          <div className="absolute inset-0 bg-purple-500/30 blur-3xl rounded-full scale-110" aria-hidden="true" data-id="element-162" />
          <img src="https://cdn.magicpatterns.com/uploads/gnFr5QhrYTY6A73VMFk3tp/36S.png" alt="36 Semanas de Música - eBook para Maestros de Primaria" className="relative w-56 sm:w-72 md:w-96 rounded-2xl shadow-2xl bounce-slow" data-id="element-163" />
        </div>

        {/* Value proposition */}
        <div className="bg-white/15 backdrop-blur-sm rounded-2xl px-5 py-4 md:px-8 md:py-5 border border-white/20 max-w-lg w-full" data-id="element-164">
          <p className="font-nunito font-black text-yellow-300 text-xl md:text-2xl lg:text-3xl" data-id="element-165">
            1 Solo eBook PDF • 60 páginas
          </p>
          <p className="text-white/90 font-semibold mt-1 text-sm md:text-base" data-id="element-166">
            Todo incluido: Planes + Plantillas + Certificados + Recursos
          </p>
        </div>

        {/* CTA Button */}
        <a href="#pricing" className="btn-pulse inline-flex items-center justify-center gap-3 w-full sm:w-auto bg-gradient-to-r from-green-400 to-emerald-500 hover:from-green-300 hover:to-emerald-400 text-white font-nunito font-black text-lg md:text-xl lg:text-2xl px-6 md:px-12 py-4 md:py-6 rounded-2xl shadow-2xl cursor-pointer transition-colors" aria-label="Comprar 36 Semanas de Música por $17 USD" data-id="element-167">
          <Zap className="w-6 h-6 flex-shrink-0" data-id="element-168" />
          <span data-id="element-169">
            SÍ, QUIERO MIS 40 SEMANAS LISTAS
            <span className="block text-sm md:text-base font-bold mt-1 text-green-100" data-id="element-170">
              Comprar Ahora — $17 USD • Acceso Inmediato
            </span>
          </span>
        </a>

        {/* Countdown */}
        <CountdownTimer data-id="element-171" />

        {/* Trust badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-white/80 text-xs md:text-sm font-semibold" data-id="element-172">
          <span className="flex items-center gap-1.5" data-id="element-173">
            <Lock className="w-4 h-4" data-id="element-174" /> Pago 100% Seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-175">
            <Shield className="w-4 h-4" data-id="element-176" /> Garantía 30 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-177">
            <ZapIcon className="w-4 h-4" data-id="element-178" /> Descarga Inmediata
          </span>
          <span className="flex items-center gap-1.5" data-id="element-179">
            <GraduationCap className="w-4 h-4" data-id="element-180" /> +1,200 Maestros
          </span>
        </div>
      </div>
    </section>;
}